import { EditLibraryOptions } from './../models/edit-library-options.model';
import { EDIT_LIBRARY_OPTIONS } from './../tokens/edit-library-options.token';
import { Injectable, Optional, Inject } from '@angular/core';
import { ComponentObject } from '../models/componet.model';
import { PageTemplate } from '../models/page-layout.model';

@Injectable()
export class PageStateService {

    private componentList: ComponentObject[] = [];
    private pageLayouts: PageTemplate[] = [];

    constructor(@Optional() @Inject(EDIT_LIBRARY_OPTIONS) private editLibraryOptions: EditLibraryOptions) {}

    setComponentList(list: ComponentObject[]) {
        this.componentList = list;
    }
    getComponentList() {
        return this.componentList;
    }
    addComponentToList(comp: ComponentObject) {
        if (this.componentList.length > 0) {
            this.componentList.push(comp);
        } else {
            this.componentList = [comp];
        }
    }
    removeComponentFromList(businessComponentId) {
        if (businessComponentId && this.componentList.length > 0) {
            for (let i = 0; i <= this.componentList.length; i++) {
                if (this.componentList[i]) {
                    let c = this.componentList[i];
                    if (c.businessComponentId === businessComponentId) {
                        this.componentList.splice(i, 1);
                    }
                }
            }
        }
    }
    // Usecase: We do not want the user to be able to add components which are already on the page
    // We provide this class with the already existing components on page (this.data.componentList)
    // This method will return the delta of non-existing component list
    removeComponentsFromList(componentRegistryList: ComponentObject[]) {
        let finalComponentList = [];
        if (!this.componentList || this.editLibraryOptions.allowDuplicateComponents) {
            // No constraint list sent, return full list from registry
            finalComponentList = componentRegistryList;
        } else {
            // We have a list of components we want to remove from list
            let existingComponents = this.componentList.map(x => {
                return x.businessComponentId;
            });
            for (let comp of componentRegistryList) {
                if (existingComponents.indexOf(comp.businessComponentId) <= -1) {
                    finalComponentList.push(comp);
                }
            }
        }
        return finalComponentList;
    }
    setPageLayouts(list: PageTemplate[]) {
        this.pageLayouts = list;
    }
    getPageLayouts() {
        return this.pageLayouts;
    }

}
